import { logEvent, setCurrentScreen, Analytics } from 'firebase/analytics';
import { analytics } from '@/config/firebase';

let analyticsInstance: Analytics | null = null;

/**
 * Инициализация Firebase Analytics
 */
export const initAnalytics = async () => {
  try {
    analyticsInstance = await analytics;
    if (analyticsInstance) {
      console.log('Firebase Analytics инициализирован');
    } else {
      console.warn('Firebase Analytics недоступен в этом браузере');
    }
  } catch (error) {
    console.error('Ошибка инициализации Firebase Analytics:', error);
  }
};

/**
 * Отслеживание просмотра страницы
 * @param path - путь страницы
 * @param title - заголовок страницы
 */
export const trackPageView = async (path: string, title?: string) => {
  const instance = analyticsInstance || await analytics;
  if (!instance) return;

  logEvent(instance, 'page_view', {
    page_path: path,
    page_title: title || document.title,
  });

  // Также устанавливаем текущий экран
  setCurrentScreen(instance, title || document.title);
};

/**
 * Отслеживание события
 * @param eventName - название события
 * @param params - параметры события
 */
export const trackEvent = async (
  eventName: string,
  params?: Record<string, any>
) => {
  const instance = analyticsInstance || await analytics;
  if (!instance) return;

  logEvent(instance, eventName as any, params);
};

/**
 * Отслеживание клика по кнопке
 */
export const trackButtonClick = (buttonName: string, location?: string) => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location,
  });
};

/**
 * Отслеживание открытия диалога
 */
export const trackDialogOpen = (dialogName: string) => {
  trackEvent('dialog_open', {
    dialog_name: dialogName,
  });
};

/**
 * Отслеживание внешних ссылок
 */
export const trackOutboundLink = (url: string, label?: string) => {
  trackEvent('click', {
    link_url: url,
    link_text: label,
    outbound: true,
  });
};

/**
 * Отслеживание поиска
 */
export const trackSearch = (searchTerm: string) => {
  trackEvent('search', {
    search_term: searchTerm,
  });
};

/**
 * Отслеживание подписки
 */
export const trackSignUp = (method?: string) => {
  trackEvent('sign_up', {
    method: method,
  });
};
